<template>
  <div>
    <h1 class="title">Unsynced Orders</h1>
    <br/><br/>
    <h4 class="title is-4">Store:</h4>
    <div class="block">
      <StoreSelector v-model="selected_store" />
    </div>
    <div class="block">
      <b-field position="is-centered">
        <b-datepicker
          placeholder="Select A Date Range"
          v-model="dates"
          icon-pack="fa"
          range
        >
        </b-datepicker>
        <b-button type='is-danger' :disabled="!dates.length" icon-pack="fa" @click="clearDateRange" icon-right="times-circle"></b-button>
        <b-button type='is-primary' :disabled="!dates.length" class="button flex-pulled-right" @click="fetchData">Search</b-button>
      </b-field>
    </div>
    <div class="block" v-if="unsyncs && unsyncs.length">
      <table class="table is-bordered" align="center">
        <thead>
            <tr>
              <th>Order ID</th>
              <th>Order Number</th>
              <th>Destination</th>
              <th>Event Date</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="order in unsyncs">
              <td><router-link class="is-info" :to="linkToOrder(order.orderid)">{{order.orderid}}</router-link></td>
              <td>{{order.order_number}}</td>
              <td>{{order.destination}}</td>
              <td>{{to_local(order.event_date)}}</td>
            </tr>
        </tbody>
      </table>
      <strong>Total {{total}}</strong>
      <b-button type='is-primary' class="button flex-pulled-right" @click="syncAll">Sync All Missing</b-button>
      <br/><br/>
    </div>
    <div class="block" v-else-if="!dates.length">
      <strong>Dates not selected</strong>
    </div>
  </div>
</template>

<script>
    import axios from 'axios'
    import auth from '../auth'
    import moment from 'moment'
    import StoreSelector from './StoreSelector'

    export default {
      name: 'UnsyncedOrders',
      computed: {
        queryParams () {
          if (this.dates) {
            this.start_date = new Date(this.dates[0])
            this.end_date = new Date(this.dates[1])
            this.start_date.setHours(0)
            this.start_date.setMinutes(0)
            this.start_date.setSeconds(0)
            this.end_date.setHours(23)
            this.end_date.setMinutes(59)
            this.end_date.setSeconds(59)
            this.start_date = this.start_date.toISOString()
            this.end_date = this.end_date.toISOString()
          }
          return {
            start_date: this.start_date,
            end_date: this.end_date,
            shop_url: this.selected_store
          }
        }
      },
      data () {
        return {
          unsyncs: [],
          dates: [],
          start_date: null,
          end_date: null,
          total: null,
          locale: 'en-CA',
          selected_store: null
        }
      },
      created () {
        auth.checkAuth(['read_orders'])
      },
      methods: {
        fetchData () {
          const loadingComponent = this.$buefy.loading.open({ container: null })
          axios.get(this.$constants.GET_UNSYNCED_ORDERS_URL, { params: this.queryParams })
            .then(response => {
              this.unsyncs = response.data
              this.total = response.data.length
              console.log(this.unsyncs)
              loadingComponent.close()
              if (!this.unsyncs.length) {
                this.$buefy.toast.open({
                  message: 'No unsynced orders for selected dates...',
                  type: 'is-info'
                })
              }
            })
            .catch(err => {
              this.unsyncs = []
              console.error(err)
            })
            .finally(resp => {
              loadingComponent.close()
            })
        },
        syncAll () {
          if (!this.unsyncs.length) {
            this.$buefy.toast.open({
              message: 'No unsynced orders to sync.',
              type: 'is-info'
            })
            return
          }
          axios.post(this.$constants.SYNC_ALL_MISSING_ORDERS_ON_DATE, {
            orders_ids: this.unsyncs.map(order => order.orderid),
            shop_url: this.selected_store
          })
            .then(response => {
              this.$buefy.toast.open({
                message: 'Sync Scheduled for all unsynced orders.',
                type: 'is-success'
              })
            })
            .catch(err => {
              this.unsyncs = []
              console.error(err)
            })
        },
        has_permissions (permissions) {
          return permissions.every(auth.hasPermission, auth.getPermissions())
        },
        clearDateRange () {
          this.dates = []
          this.start_date = null
          this.end_date = null
        },
        onPageChange (page) {
          this.page = page
          this.fetchData()
        },
        to_local (utcDT) {
          return moment(utcDT).format('YYYY/MM/DD HH:mm:ss')
        },
        linkToOrder (orderId) {
          return `order_status_view/${orderId}`
        }
      },
      components: {
        StoreSelector
      }
    }

</script>

